import { Col, Grid, Row } from "antd";
import { useMemo } from "react";
import Introduction from "./Introduction/Introduction";
import style from "./Home.module.less";
import SkillCards from "./SkillCards/SkillCards";
import HeaderImgLaptop from "../../assets/laptop1.svg"
import { RouterPageProps } from "../../classesAndInterfaces/generalInterfaces";
import Technologies from "./Technologies/Technologies";

const Home: RouterPageProps = () => {
  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();

  /**
   * @memorized value for card sizes width according to screen
   */
  const intro_col_span: number = useMemo(() => {
    const screens = Object.entries(breakpoints).filter((screen) => !!screen[1]);
    const screen_size = screens[screens.length - 1]?.[0];
    switch (screen_size) {
      case "md":
        return 16;
      case "sm":
        return 24;
      case "xs":
        return 24;
      default:
        return 16;
    }
  }, [breakpoints]);

  const illustration_col_span: number = useMemo(() => {
    const screens = Object.entries(breakpoints).filter((screen) => !!screen[1]);
    const screen_size = screens[screens.length - 1]?.[0];
    switch (screen_size) {
      case "xxl":
        return 6;
      case "md":
        return 8;
      case "sm":
        return 0;
      case "xs":
        return 0;
      default:
        return 8;
    }
  }, [breakpoints])

  return (
    <Row gutter={[32,32]} align={"middle"} justify={"center"} className={style.body}>
      <Col span={21}>
        <Row gutter={[32,32]} align={"middle"} justify={"space-between"} className={style.glass_morphism}>
          <Col span={intro_col_span}>
            <Introduction />
          </Col>
          <Col span={illustration_col_span}>
            <img src={HeaderImgLaptop} alt={"header"}/>
          </Col>
        </Row>
      </Col>
      <Col span={20}>
        <SkillCards />
      </Col>
      <Col span={20}>
        <Technologies />
      </Col>
    </Row>
  );
};

export default Home;
